import { ANALYTICS_MIN_DATE_STR } from "@/pages/CreatorAnalytics/constants";

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const MIN_MONTH = 1;
const MAX_MONTH = 12;
const MIN_DAY = 1;
const MAX_DAY = 31;
const FUTURE_YEAR_BUFFER = 1;

// Parse the year directly from the YYYY-MM-DD string instead of going through
// `new Date(...).getFullYear()`. The Date constructor treats an ISO date as
// UTC midnight, but `getFullYear()` reports it in the user's local timezone,
// so for any negative UTC offset (e.g. Americas) we'd get year - 1 here and
// silently allow dates before ANALYTICS_MIN_DATE_STR through validation.
const MIN_YEAR = Number(ANALYTICS_MIN_DATE_STR.split("-")[0]);

const parseAnalyticsDateInput = (value: string): Date | null => {
  if (!ISO_DATE_PATTERN.test(value)) {
    return null;
  }

  const [yearStr, monthStr, dayStr] = value.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);

  const maxYear = new Date().getFullYear() + FUTURE_YEAR_BUFFER;
  if (year < MIN_YEAR || year > maxYear) {
    return null;
  }
  if (month < MIN_MONTH || month > MAX_MONTH) {
    return null;
  }
  if (day < MIN_DAY || day > MAX_DAY) {
    return null;
  }

  const result = new Date(year, month - 1, day);
  if (Number.isNaN(result.getTime())) {
    return null;
  }

  // Reject overflow normalisation (e.g. Feb 31 -> Mar 3).
  if (result.getFullYear() !== year || result.getMonth() !== month - 1 || result.getDate() !== day) {
    return null;
  }

  return result;
};

export default parseAnalyticsDateInput;
